import { commentConstant } from "../constants/commentConstant";
import type { OpportunityComment } from "../../containers/Pipelines/types";

interface CommentState {
  commentsByOpportunity: Record<number, OpportunityComment[]>; // Map of opportunityId -> comments
  loading: boolean;
  error: any | null;
}

interface CommentAction {
  type: string;
  data?: any;
  payload?: any;
  error?: any;
}

const initialState: CommentState = {
  commentsByOpportunity: {},
  loading: false,
  error: null,
};

export default function comment(state = initialState, action: CommentAction): CommentState {
  switch (action.type) {
    // Get Comments by Opportunity
    case commentConstant.GET_COMMENTS_BY_OPPORTUNITY_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case commentConstant.GET_COMMENTS_BY_OPPORTUNITY_S: {
      const { opportunityId, comments } = action.data || {};
      return {
        ...state,
        commentsByOpportunity: {
          ...state.commentsByOpportunity,
          [opportunityId]: comments || [],
        },
        loading: false,
      };
    }

    case commentConstant.GET_COMMENTS_BY_OPPORTUNITY_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Get Comment Count
    case commentConstant.GET_COMMENT_COUNT_R:
      return {
        ...state,
        error: null,
      };

    case commentConstant.GET_COMMENT_COUNT_S:
      return {
        ...state,
      };

    case commentConstant.GET_COMMENT_COUNT_F:
      return {
        ...state,
        error: action.error,
      };

    // Create Comment
    case commentConstant.CREATE_COMMENT_R:
      return {
        ...state,
        error: null,
      };

    case commentConstant.CREATE_COMMENT_S: {
      const { opportunityId, comment } = action.data || {};
      const existingComments = state.commentsByOpportunity[opportunityId] || [];
      return {
        ...state,
        commentsByOpportunity: {
          ...state.commentsByOpportunity,
          [opportunityId]: comment ? [comment, ...existingComments] : existingComments,
        },
      };
    }

    case commentConstant.CREATE_COMMENT_F:
      return {
        ...state,
        error: action.error,
      };

    // Update Comment
    case commentConstant.UPDATE_COMMENT_R:
      return {
        ...state,
        error: null,
      };

    case commentConstant.UPDATE_COMMENT_S: {
      const { opportunityId, commentId, comment } = action.data || {};
      const existingComments = state.commentsByOpportunity[opportunityId] || [];
      return {
        ...state,
        commentsByOpportunity: {
          ...state.commentsByOpportunity,
          [opportunityId]: existingComments.map((c) =>
            c.id === commentId ? comment : c
          ),
        },
      };
    }

    case commentConstant.UPDATE_COMMENT_F:
      return {
        ...state,
        error: action.error,
      };

    // Delete Comment
    case commentConstant.DELETE_COMMENT_R:
      return {
        ...state,
        error: null,
      };

    case commentConstant.DELETE_COMMENT_S: {
      const { opportunityId, commentId } = action.data || {};
      const existingComments = state.commentsByOpportunity[opportunityId] || [];
      return {
        ...state,
        commentsByOpportunity: {
          ...state.commentsByOpportunity,
          [opportunityId]: existingComments.filter((c) => c.id !== commentId),
        },
      };
    }

    case commentConstant.DELETE_COMMENT_F:
      return {
        ...state,
        error: action.error,
      };

    // Clear State
    case commentConstant.CLEAR_COMMENTS_STATE:
      return initialState;

    default:
      return state;
  }
}
